import { watch } from "vue";
import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { useNgSession } from "@sazka/ng/ng-session";

export const invokeWithLogin = async <T>(fn: () => T): Promise<T> => {
    const { isLoggedIn } = useNgSession();
    await ngFrameworkLoaded();
    if (isLoggedIn.value) {
        return await fn();
    } else {
        ng_fw.showLogin();
        return new Promise((resolve) => {
            watch(isLoggedIn, async (loggedIn) => {
                if (loggedIn) {
                    resolve(await fn());
                }
            });
        });
    }
};
